import React from 'react';
import styles from './SkillTag.module.css';

interface SkillTagProps {
  skill: string;
}

const SkillTag: React.FC<SkillTagProps> = ({ skill }) => {
  return (
    <span className={styles.tag}>
      <span className={styles.icon}>&#9881;</span>
      {skill}
    </span>
  );
};

export default SkillTag;
